module.exports = new __parcel__URL__("orangeBar.96a843e1.svg").toString();